import { ReducersMapObject } from '@reduxjs/toolkit';

import commonReducers, { CommonUnionState } from 'common/reducers';
import usersReducers, { CommonUsersState } from 'users/reducers';
import affiliatesReducers, { AffiliatesUnionState } from 'affiliates/reducers';

export type StoreState = CommonUnionState &
  CommonUsersState &
  AffiliatesUnionState;

const rootReducer: ReducersMapObject<StoreState> = {
  ...commonReducers,
  ...usersReducers,
  ...affiliatesReducers,
};

export default rootReducer;
